<template>
  <div
    v-if="appHasFiscalDocsEnabled && appHasFiscalDocsProvider && appFiscalDocsProvider === FiscalDocsProviderEnum.IMPACT"
    style="height: 100%; display: table; cursor: pointer;"
    @click="onViewFiscalDocuments"
  >
    <div
      class="pl-0"
      style="display: table-cell; vertical-align: top;"
    >
      <v-tooltip
        :disabled="userInAdminGroup ? !appOnlineAdminUsers.count : !appOnlineTotalUsers.count"
        bottom
        color="blue lighten-5"
        max-width="300px"
        min-width="300px"
      >
        <template #activator="{on}">
          <div
            :class="[isOnline ? 'blue lighten-5' : 'red lighten-3']"
            class="rounded"
            style="height: 100%; width: 60px; display: table;"
            v-on="on"
          >
            <div
              class="white--text"
              style="display: table-cell; text-align: center; vertical-align: middle; line-height: 10px;"
            >
              <my-data-logo
                :bg-color="isOnline ? 'blue lighten-5' : 'red lighten-3'"
                img-class="mt-1 mb-2"
                width="45"
              />

              <div :class="[isOnline ? 'blue--text text--darken-3' : 'red--text']">
                <div style="font-size: 10px; font-weight: 900;">
                  {{ isOnline ? 'ONLINE' : 'OFFLINE' }}
                </div>
              </div>
            </div>
            <span
              v-if="!isOnline"
              class="red rounded-r"
              style="display: table-cell; height: 100%; width: 7px;"
            />
            <span
              v-else
              class="blue darken-3 rounded-r"
              style="display: table-cell; height: 100%; width: 7px;"
            />

            <v-badge
              v-if="hasOpenFiscalDocuments && userIsSuperAdmin"
              class="pulse-badge"
              color="blue darken-3"
              left
              overlap
              style="top: 8px; right: 8px; z-index: 1;"
            >
              <template #badge>
                <v-icon>mdi-exclamation-thick</v-icon>
              </template>
            </v-badge>
          </div>
        </template>

        <div>
          <div>
            <div class="d-inline-flex">
              <my-data-logo
                img-class="mt-2"
                width="45"
              />
            </div>

            <div :class="[isOnline ? 'blue--text text--darken-3' : 'red--text', 'd-inline-flex float-end mt-1']">
              <div style="font-size: 12px; font-weight: 900;">
                {{ isOnline ? 'ONLINE' : 'OFFLINE' }}
              </div>
            </div>
          </div>

          <template v-if="hasOpenFiscalDocuments">
            <v-divider
              class="mb-1"
              light
            />

            <div
              v-safe-html="$tc('Receipt.DocumentsStatus.Warning', appFiscalDocsProviderCloseFnbDocuments.InInfo, {minHours: appFiscalDocsProviderCloseFnbDocuments.InInfo, maxHours: appFiscalDocsProviderCloseFnbDocuments.In})"
              class="blue--text text--darken-3 text-caption text-justify"
            />
          </template>
        </div>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import MyDataLogo from '@/components/receipts/MyDataLogo.vue'
import FiscalDocsProviderEnum from '@/api/Enums/FiscalDocsProviderEnum.js'

export default {
  name      : 'MyDataStatus',
  components: {MyDataLogo},
  mixins    : [AppData, Auth],
  props     : [],
  data() {
    return {}
  },
  computed: {
    FiscalDocsProviderEnum() {
      return FiscalDocsProviderEnum
    },
    isOnline() {
      return this.myDataStatus
    },
    hasOpenFiscalDocuments() {
      return this.documentsStatus
    }
  },
  methods: {
    onViewFiscalDocuments() {
      if (this.userIsDelivery) return

      if (this.$route.name === 'Receipts') {
        if (this.userIsSuperAdmin) this.$bus.$emit('receipts:filterOpenFiscalDocuments', {})
      } else {
        this.$router.push({
          name  : 'Receipts',
          params: {hasOpenFiscalDocuments: this.hasOpenFiscalDocuments && this.userIsSuperAdmin}
        })
      }
    }
  }
}
</script>
